import MoreVertIcon from '@material-ui/icons/MoreVert';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

export const MoreIcon = styled(MoreVertIcon)`
    :hover {
        cursor: pointer;
    }
`

export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(1),
        zIndex: 100000,
        width: 200,
        position: 'absolute'
    },
}));
 
export const FixButton = styled(Button)`
    width: 100%;
`